module.exports = __webpack_public_path__ + "static/media/ExtremeWireless-AirDefense-Logo_RGB.be5c96fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ExtremeWireless-AirDefense-Logo_RGB.png
// module id = 35
// module chunks = 0